import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ScrollToTop from './utils/scrollToTop';
import CookieConsentModal from './utils/cookiePopup/cookiePopup';
import StructuredData from './utils/hoc/structuredData';

import Header from './components/header';
import Footer from './components/footer';
import ScrollTopButton from './components/scrollTopButton';
import BookAppointmentButton from './components/bookAppointmentButton/bookAppointmentButton';
import AppRoutes from './utils/appRoutes/approutes';

import './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import './global.scss';
import { AOSWrapper } from './utils/hoc/aosWrapper';

const App = () => {
  const myRef = useRef(null);

  // ✅ initialize from localStorage
  const [isAnalyticsAllowed, setAnalyticsAllowed] = useState(
    localStorage.getItem('cookieConsent') === 'accepted',
  );

  // ✅ set default consent on FIRST load (VERY IMPORTANT)
  useEffect(() => {
    if (window.gtag) {
      window.gtag('consent', 'default', {
        analytics_storage: 'denied',
      });
    }
  }, []);

  // ✅ update consent whenever state changes
  useEffect(() => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: isAnalyticsAllowed ? 'granted' : 'denied',
      });
    }
  }, [isAnalyticsAllowed]);

  return (
    <Router>
      <AOSWrapper />
      <ScrollToTop />
      <StructuredData />

      <CookieConsentModal onConsentChange={setAnalyticsAllowed} />

      <BookAppointmentButton />
      <Header myRef={myRef} />

      <div className="myBody">
        <AppRoutes myRef={myRef} />
      </div>

      <Footer />
      <ScrollTopButton />
    </Router>
  );
};

export default App;
